// OrderConfirmPage.js
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getOrder } from '../utils/api';
import { formatDate, ORDER_STATUS_COLORS } from '../utils/helpers';
import { FiCheckCircle, FiPackage } from 'react-icons/fi';

export default function OrderConfirmPage() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    getOrder(id).then(r => setOrder(r.data)).catch(() => {});
  }, [id]);

  if (!order) return <div className="page-loader"><div className="spinner" /></div>;

  return (
    <div className="container" style={{ padding: '2rem 1rem', maxWidth: 640 }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <FiCheckCircle size={60} color="var(--success)" />
        <h1 style={{ fontSize: '1.75rem', fontWeight: 800, marginTop: '0.75rem' }}>Order Placed! 🎉</h1>
        <p style={{ color: 'var(--text-secondary)', marginTop: '0.5rem' }}>Thank you, your order has been received.</p>
      </div>
      <div className="card" style={{ padding: '1.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <div>
            <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Order Number</p>
            <p style={{ fontWeight: 800, fontSize: '1.1rem', color: 'var(--primary)' }}>#{order.orderNumber}</p>
          </div>
          <span className="badge badge-warning">{ORDER_STATUS_COLORS[order.status]?.label}</span>
        </div>
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {order.items.map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
              <img src={item.image} alt={item.name} style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover' }} />
              <div style={{ flex: 1 }}>
                <p style={{ fontWeight: 600, fontSize: '0.875rem' }}>{item.name}</p>
                <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>×{item.quantity} — ৳{item.price.toLocaleString()}</p>
              </div>
            </div>
          ))}
        </div>
        <div style={{ borderTop: '1px solid var(--border)', marginTop: '1rem', paddingTop: '1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: '1.05rem' }}>
            <span>Total Paid</span>
            <span style={{ color: 'var(--accent)' }}>৳{order.totalPrice.toLocaleString()}</span>
          </div>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginTop: '0.375rem' }}>Payment: {order.paymentMethod?.toUpperCase()} | {formatDate(order.createdAt)}</p>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
          <Link to="/orders" className="btn btn-primary btn-block"><FiPackage size={14} /> Track Order</Link>
          <Link to="/products" className="btn btn-outline btn-block">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
